import React from 'react';
import { Play } from 'lucide-react';
import { Dialog, DialogContent, DialogTrigger } from './ui/dialog';

const videoReviews = [
  { id: 'PSC-N1gEnT8' },
  { id: 'e3q_0U9sojw' },
  { id: 'cL8cyPOL5hw' },
];

const VideoReviews = () => {
  return (
    <section data-testid="video-reviews-section" className="py-24" style={{ backgroundColor: '#FAF8F5' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="text-center mb-12">
          <p className="text-gold text-sm font-semibold uppercase tracking-widest mb-4">Don't take our word for it</p>
          <h2 className="font-serif text-4xl sm:text-5xl text-gray-900 mb-4">Hear it from real couples.</h2>
          <p className="text-gray-600 text-lg">Unscripted. Straight from the heart.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {videoReviews.map((review, i) => (
            <Dialog key={review.id}>
              <DialogTrigger asChild>
                <div
                  data-testid={`video-review-${review.id}`}
                  className="relative aspect-video rounded-xl overflow-hidden cursor-pointer group shadow-lg"
                >
                  <img
                    src={`https://img.youtube.com/vi/${review.id}/maxresdefault.jpg`}
                    alt="Couple review"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-all flex items-center justify-center">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-xl">
                      <Play className="w-7 h-7 text-black ml-0.5" />
                    </div>
                  </div>
                  <div className="absolute top-3 left-3 bg-gold text-black text-xs font-bold px-3 py-1 rounded-full">
                    COUPLE REVIEW
                  </div>
                </div>
              </DialogTrigger>
              <DialogContent className="max-w-4xl p-0 bg-black border-none">
                <div className="aspect-video">
                  <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${review.id}?autoplay=1&rel=0&modestbranding=1`}
                    title="Couple Review"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </DialogContent>
            </Dialog>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoReviews;
